'use client';

import React, { ReactNode, createContext, useContext, useState } from 'react';

type IProviderLibraryProvider = {
  children: ReactNode;
};

type IProviderLibraryContext = {
  providerLibraryData: any;
  updateProviderLibraryData: (data: any) => void;
  getSingleProviderLibraryData: (data: any) => void;
  //   updateSingleDataManagementData: any;
  //   dataManagementData: any;
  //   updateDataManagementData: any;
  //   resetDataManagementData: any;
};

export const ProviderLibraryContext = createContext({} as IProviderLibraryContext);

export function useProviderLibraryContext() {
  return useContext(ProviderLibraryContext);
}

export function ProviderLibraryProvider({ children }: IProviderLibraryProvider) {
  //   const [events, setEvents] = useState<any>();
  const [providerLibraryData, setProviderLibraryData] = useState<any[]>([]);
  const updateProviderLibraryData = (data: any) => {
    // setProviderLibraryData((prev: any) => [...prev, ...data]);
    // if(providerLibraryData.length>0)return;
    setProviderLibraryData(data);
  };

  const getSingleProviderLibraryData = (id: any) => {
    const data = providerLibraryData?.filter((item: any) => {
      return item?.product_id === id;
    });
    return data;
  };
  //   const updateSingleDataManagementData = (data: any) => {
  //     setDataManagementData((prev: any) => {
  //       const newArray = [...prev];
  //       const index = newArray?.findIndex((item: any) => item?.id === data?.id);
  //       newArray[index] = data;
  //       return newArray;
  //     });
  //   };
  //   const resetDataManagementData = () => {
  //     setDataManagementData([]);
  //   };

  //   useEffect(() => {
  //     const startLoaderEvent = new CustomEvent('startLoading');

  //     const stopLoaderEvent = new CustomEvent('stopLoading');
  //     setEvents({ startLoaderEvent, stopLoaderEvent });
  //   }, []);

  return (
    <ProviderLibraryContext.Provider
      value={{
        providerLibraryData,
        updateProviderLibraryData,
        getSingleProviderLibraryData,
        // dataManagementData,
        // updateDataManagementData,
        // resetDataManagementData,
        // updateSingleDataManagementData,
      }}
    >
      {children}
    </ProviderLibraryContext.Provider>
  );
}
